import React from "react";

const StatusStore = ({ status }) => {



  // اختيار التنسيق المناسب
const { bg, color, label } = status ==="free"? {
bg: "#E6F7F1", // أخضر فاتح
      color: "#0E7C66", // أخضر غامق
  label: "متاح للعمل",
} : status ==="busy"?{
        bg: "#FFF8E1", // أصفر فاتح
      color: "#F1B100", // أصفر غامق
      label: "مشغول الان",
}:status ==="close" ?{
      bg: "#FDEAEA", // أحمر فاتح
      color: "#E53935", // أحمر غامق
      label: "مغلق",
    }:""

  return (
    <span
      style={{
        backgroundColor: bg,
        color: color,
        padding: "6px 16px",
        borderRadius: "12px",
        fontWeight: "500",
        fontSize: "14px",
        display: "inline-block",
        textAlign: "center",
        minWidth: "100px",
      }}
    >
      {label}
    </span>
  );
};

export default StatusStore;
